import { render, staticRenderFns } from "./deleteSpvNode.vue?vue&type=template&id=6d6262ab&scoped=true&"
import script from "./deleteSpvNode.vue?vue&type=script&lang=js&"
export * from "./deleteSpvNode.vue?vue&type=script&lang=js&"
import style0 from "./deleteSpvNode.vue?vue&type=style&index=0&id=6d6262ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6262ab",
  null
  
)

export default component.exports